import { CustomDialog } from '../../components/CustomDialog';
import { useState } from 'react';
import {
  Button,
  DatePickerController,
} from '../../components';
import { downLoadLink } from '../../utils/functions/common';
import { useAppDispatch } from '../../storeHook';
import { showAlert } from '../../services/alert';
import { useLazyExportDeliverySchedulesQuery } from '../../services/deliverySchedules';
import * as yup from 'yup';
import { useFormWithSchema } from '../../utils/functions/yupFormTypescript';
import dayjs from 'dayjs';
import { TDeliveryScheduleTab } from '../../utils/types';
import MultiSelect from '../../components/formControllers/multiSelect';
import { useGetAllPlantsQuery } from '../../services/common';

const currDate = new Date();
const formSchema = yup.object({
  deliveryStatus: yup.array(yup.string().required()),
  werks: yup.array(yup.string().required()),
  startDate: yup
    .date()
    .required('Start Date is required')
    .default(dayjs(currDate).subtract(1, 'days').toDate()),
  endDate: yup
    .date()
    .required('End Date is required')
    .default(dayjs(currDate).toDate()),
});
type TFormData = yup.InferType<typeof formSchema>;

export const DeliveryScheduleExport: React.FC<{
  activeTab: TDeliveryScheduleTab;
}> = ({ activeTab }) => {
  const { data: plantList } = useGetAllPlantsQuery();
  const {
    formState: { errors },
    handleSubmit,
    control,
    watch,
  } = useFormWithSchema(formSchema, {
    mode: 'onTouched',
    defaultValues: {
      deliveryStatus: activeTab.status
        ? [activeTab.status]
        : undefined,
    },
  });

  const dispatch = useAppDispatch();
  const [exportDeliverySchedules] =
    useLazyExportDeliverySchedulesQuery();
  const [open, setOpen] = useState(false);

  const onExportClick = (data: TFormData) => {
    exportDeliverySchedules({
      deliveryStatus: data.deliveryStatus,
      startDate: dayjs(data.startDate).format('DD-MM-YYYY'),
      endDate: dayjs(data.endDate).format('DD-MM-YYYY'),
      werks: data.werks,
    })
      .unwrap()
      .then((res) => {
        downLoadLink(res.url);
        dispatch(
          showAlert({
            content: res.url
              ? 'Orders Exported Successfully'
              : 'No data found with applied conditions',
            severity: res.url ? 'success' : 'error',
          })
        );
      })
      .catch((err) => {
        console.log('error', err);
        // this.utility.handleError(err);
      });
  };

  return (
    <>
      <Button
        onClick={() => setOpen(!open)}
        className="ml-2"
        variant="button--secondary">
        Export
      </Button>
      <CustomDialog
        dialogTitle={'Delivery Schedule Export'}
        open={open}
        setOpen={setOpen}
        onSubmit={handleSubmit((data) =>
          onExportClick(data)
        )}
        actionText={{ submit: 'Export', cancel: 'Cancel' }}
        maxWidth="md"
        disableAccept={
          !(watch('startDate') || watch('endDate'))
        }>
        <form
          onSubmit={handleSubmit((data) =>
            onExportClick(data)
          )}
          className="mb-10 grid grid-cols-2 gap-x-5 pb-20">
          <DatePickerController
            label="Start Date"
            control={control}
            name="startDate"
            error={errors.startDate?.message}
            selectsStart
            startDate={watch('startDate')}
            endDate={watch('endDate')}
          />
          <DatePickerController
            label="End Date"
            control={control}
            name="endDate"
            error={errors.endDate?.message}
            selectsEnd
            startDate={watch('startDate')}
            endDate={watch('endDate')}
          />
          <MultiSelect
            label="Plants"
            name="werks"
            control={control}
            options={plantList?.map((ele) => ({
              value: ele.plantCode,
              label: `${ele.plantName} [${ele.plantCode}]`,
            }))}
            error={errors.werks?.message}
          />
          <MultiSelect
            label="Delivery Status"
            name="deliveryStatus"
            control={control}
            options={activeTab.statusOptions}
            error={errors.deliveryStatus?.message}
          />
        </form>
      </CustomDialog>
    </>
  );
};
